import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import {
  ChatIcon,
  EmailIcon,
  MoreIcon,
  NoteIcon,
  PhoneIcon,
} from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { InteractionTypeEnum, InteractionTypeLabel } from '../../Servicing.constants';
import { typeIconStyles } from '../ServiceLog.styles';

const INTERACTION_TYPE_ICON_MAP = {
  [InteractionTypeEnum.INBOUND_CALL]: PhoneIcon,
  [InteractionTypeEnum.OUTBOUND_CALL]: PhoneIcon,
  [InteractionTypeEnum.EMAIL]: EmailIcon,
  [InteractionTypeEnum.LETTER]: NoteIcon,
  [InteractionTypeEnum.IN_PERSON]: ChatIcon,
  [InteractionTypeEnum.OTHER]: MoreIcon,
};

const TypeIcon = ({ row }) => {
  const IconComponent = INTERACTION_TYPE_ICON_MAP[row.interactionType] ?? MoreIcon;
  const label = InteractionTypeLabel[row.interactionType] ?? '-';

  return (
    <Box sx={typeIconStyles}>
      <IconComponent size={IconSize[16]} />
      <Typography variant="medium12">{label}</Typography>
    </Box>
  );
};

TypeIcon.propTypes = {
  row: PropTypes.object.isRequired,
};

export default memo(TypeIcon);
